import { PartyImage } from '@approvalmax/ui';
import { Button, Flex, Popup, Text } from '@approvalmax/ui/src/components';
import { memo } from 'react';
import { getPath, Path } from 'urlBuilder';

import { messages } from './SuccessPopupContent.messages';
import { SuccessPopupContentProps } from './SuccessPopupContent.types';

export const SuccessPopupContent = memo<SuccessPopupContentProps>((props) => {
    const { reportConfig, requestId } = props;

    return (
        <>
            <Popup.Header />

            <Popup.Body spacing='32'>
                <Flex spacing='24' direction='column' alignItems='center'>
                    <PartyImage />

                    <Text font='headline' fontSize='small' textAlign='center'>
                        {messages.title}
                    </Text>

                    <Text font='body' fontSize='medium'>
                        {messages.description}
                    </Text>

                    <Button
                        color='blue80'
                        size='large'
                        as='a'
                        href={getPath(Path.editRequest, requestId, reportConfig.companyId)}
                        target='_blank'
                    >
                        {messages.buttonText}
                    </Button>
                </Flex>
            </Popup.Body>
        </>
    );
});

SuccessPopupContent.displayName = 'SuccessPopupContent';
